import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/axiosInstance";
import { Footer2 } from "../footer2";
import Header2 from "../header2/index-two";
import { useNavigate } from "react-router-dom";
import qs from "query-string";
import "../home2/home.css";
import usePageTracking from "../../hooks/usePageTracking";

// default: searchkeyword artık boş
const defaultCriteria = {
  typename: "all",
  attributename: "",
  searchkeyword: "",   // ← eskiden "*"
  operator: "or",
};

const AdvancedSearch = () => {
  usePageTracking("advanced-search");
  const [options, setOptions] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState([{ ...defaultCriteria }]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await axiosInstance.get(
          "publicationSearch/getTypeList"
        );
        const data = res.data?.data ?? [];
        // ensure OK status if present
        if (res.data?.status && res.data.status !== "OK") return;

        // isim düzeltmeleri (EISSN/EISBN -> E-ISSN/E-ISBN)
        const fixed = data.map((it) => {
          const web = it.webname === "EISSN" ? "E-ISSN" : it.webname === "EISBN" ? "E-ISBN" : it.webname;
          return { ...it, webname: web };
        });

        // sıralama (home2 ile birebir)
        const sortOrder = [
          "Tümü",
          "Başlık",
          "Anahtar Kelime",
          "Özet",
          // "Konu Başlıkları",
          "İçerik",
          "Yazar",
          "ISBN",
          "ISSN",
          "E-ISBN",
          "E-ISSN",
        ];

        fixed.sort((a, b) => {
          const ia = sortOrder.indexOf(a.webname);
          const ib = sortOrder.indexOf(b.webname);
          if (ia === -1 && ib === -1) return (a.webname || "").localeCompare(b.webname || "");
          if (ia === -1) return 1;
          if (ib === -1) return -1;
          return ia - ib;
        });

        // dropdown'da göstermemek istediğimiz webname'leri çıkar
        const excludeLower = new Set(["cilt", "sayı", "yayın yeri", "konu başlıkları"]);

        const formatted = fixed
          .filter((item) => {
            const name = (item.webname || "").toString().trim().toLowerCase();
            return !excludeLower.has(name);
          })
          .map((item) => ({
            value: item.attributename, // select value: attributename (home2 behavior)
            label: item.webname === "İçerik" ? "Tam Metin" : item.webname,
            typename: item.typename,
            attributename: item.attributename,
          }));

        const withAll = [
          { value: "", label: "Tümü", typename: "all", attributename: "" },
          ...formatted,
        ];

        const deduped = Array.from(new Map(withAll.map((o) => [o.attributename, o])).values());
        setOptions(deduped);
      } catch (err) {
        console.error("Error fetching options:", err);
      }
    };

    fetchOptions();
  }, []);

  const handleAddCriteria = () => {
    setSearchCriteria((prev) => [...prev, { ...defaultCriteria }]);
  };

  const handleRemoveCriteria = (index) => {
    setSearchCriteria((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated.length > 0 ? updated : [{ ...defaultCriteria }];
    });
  };

  const handleChange = (index, field, value) => {
    setSearchCriteria((prev) =>
      prev.map((c, i) => (i === index ? { ...c, [field]: value } : c))
    );
  };

  const handleAttributeChange = (index, newAttributeName) => {
    const selectedOption = options.find((opt) => opt.attributename === newAttributeName);
    setSearchCriteria((prev) =>
      prev.map((c, i) =>
        i === index
          ? {
              ...c,
              attributename: selectedOption?.attributename ?? "",
              typename: selectedOption?.typename ?? "all",
            }
          : c
      )
    );
  };

  // boş satırları tamamen at; kalanları normalize et
  const buildCriteriaForQuery = (arr) => {
    const nonEmpty = arr.filter(c => (c.searchkeyword || "").trim().length > 0);
    return nonEmpty.map((c, idx) => ({
      typename: c.typename || "all",
      attributename: c.attributename === "Tümü" ? "" : (c.attributename ?? ""),
      searchkeyword: c.searchkeyword.trim(),
      operator: idx === 0 ? "or" : (c.operator || "and"),
    }));
  };

  const hasAnyTerm = searchCriteria.some(c => (c.searchkeyword || "").trim().length > 0);

  const handleSearch = () => {
    if (!hasAnyTerm) return; // boş gönderimi engelle

    const fixedCriteria = buildCriteriaForQuery(searchCriteria);
    if (fixedCriteria.length === 0) return;

    const paramsObj = {
      publicationAdvantageSearchDTOList: JSON.stringify(fixedCriteria),
      status: "1",
      page: "1",
      size: "20",
      sort: "relevance",
    };

    const query = qs.stringify(paramsObj, { skipNull: true, skipEmptyString: true });
    navigate(`/publication-list?${query}`);
  };

  const handleClear = () => {
    setSearchCriteria([{ ...defaultCriteria }]);
  };

  return (
    <div className="main-wrapper" style={{ background: "#f8fafc", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header2 />
      
      {/* Ana içerik alanını esnek şekilde ortalamak için */}
      <main className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ background: "#f8fafc" }}>
        <section className="w-100 py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-xl-8 mt-5"> {/* Daha dar ve merkezde bir sütun */}
                <div className="p-4 rounded-4 shadow bg-white my-5">
                  <div className="mb-4 text-center"> {/* Başlığı da ortala */}
                    <h3 className="fw-semibold fs-4 mb-0 text-newdarkfume">Detaylı Arama</h3>
                  </div>

                  {searchCriteria.map((criteria, index) => (
                    <div key={index} className="d-flex align-items-center mb-3 flex-wrap gap-2">
                      {index !== 0 && (
                        <select
                          className="form-select rounded-3 bg-light text-darkfume"
                          value={criteria.operator}
                          onChange={(e) => handleChange(index, "operator", e.target.value)}
                          style={{ minWidth: 90 }}
                        >
                          <option value="and">VE</option>
                          <option value="or">VEYA</option>
                          <option value="not">DEĞİL</option>
                        </select>
                      )}

                      <div className="d-flex flex-row flex-grow-1 gap-2 align-items-center" style={{ minWidth: 0 }}>
                        <input
                          className="form-control rounded-3 bg-light text-darkfume flex-grow-1"
                          type="text"
                          placeholder="Arama terimi"
                          value={criteria.searchkeyword || ""}   // ← boş başlar
                          onChange={(e) => handleChange(index, "searchkeyword", e.target.value)}
                          style={{ minWidth: 120 }}
                        />

                        <select
                          className="form-select rounded-3 bg-light text-darkfume"
                          value={criteria.attributename}
                          onChange={(e) => handleAttributeChange(index, e.target.value)}
                          style={{ minWidth: 140, maxWidth: 180 }}
                        >
                          {options.map((option) => (
                            <option key={option.attributename} value={option.attributename}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <button
                        className="btn p-0 ms-1 fs-3 text-muted border-0 bg-transparent"
                        style={{ boxShadow: "none" }}
                        onClick={() => handleRemoveCriteria(index)}
                        title="Kriteri Sil"
                      >
                        ×
                      </button>
                    </div>
                  ))}

                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-primary rounded-3 px-4 py-2 mt-2 text-sm fw-semibold"
                      onClick={handleAddCriteria}
                    >
                      + Kriter Ekle
                    </button>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-primary rounded-3 px-4 py-2 fw-semibold text-sm mt-2"
                        onClick={handleClear}
                      >
                        Temizle
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-4 py-2 mt-2 text-sm fw-semibold"
                        onClick={handleSearch}
                        disabled={!hasAnyTerm}               // boşken pasif
                        title={!hasAnyTerm ? "En az bir arama terimi girin" : "Ara"}
                      >
                        Ara
                      </button>
                    </div>
                  </div>
                </div>

                {/* Alt filtre blokları kaldırıldı */}
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer2 />
    </div>
  );
};

export default AdvancedSearch;